__turbopack_context__.v({
  "DashboardContent": "dash-module__mtM9-a__DashboardContent",
  "dashboard": "dash-module__mtM9-a__dashboard",
  "dashboardIcon": "dash-module__mtM9-a__dashboardIcon",
  "editprofilebtn": "dash-module__mtM9-a__editprofilebtn",
  "link": "dash-module__mtM9-a__link",
});
